// Visit The Stimulus Handbook for more details 
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mitigation"]
  static values = { id: Number }
  connect() { 
    console.log("Mitigation js loaded")
  } 

  toggle() {
    // User has clicked the tag 
    console.log("Mitigation Toggling")
    this.refresh(document.querySelector("#mitigated_mitigation"))
  }  

  refresh(field) {
    if (field.value == this.idValue)
      field.value = ""
    else
      field.value = this.idValue

    field.closest('form').dispatchEvent(new Event('input'))
  } 
}
